import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';
import { BigBreadcrumbs } from '../../../components';
import {
  requestQueryBuilderData,
  performSearch,
  requestTypeahead,
  requestQueries,
  addQuery,
  deleteQuery,
} from '../../../store/query-builder/QueryBuilderActions';
import QueryBuilder from '../components/QueryBuilder/QueryBuilder';
import QueryList from '../components/QueryBuilder/QueryList';
import { hostTitle } from '../../../config/ui';

function QueryBuilderContainer(props) {
  const [initValue, setInitValue] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState('');
  const [params, setParams] = useState({
    offset: 0,
    limit: 25,
  });

  useEffect(() => {
    if (!props.queryBuilder.data && !props.queryBuilder.isLoading) {
      props.getQueryBuilderData({
        ...props.currentUser.queryParams,
      });
    }
    if (!props.queryBuilder.queries && !props.queryBuilder.isQueriesLoading) {
      props.getQueries(props.currentUser.data.id);
    }
  });

  const performSearchFn = (val, explicitParams = null) => {
    setQuery(val);
    return props
      .performSearch(val, explicitParams ? explicitParams : params)
      .then(response => {
        if (response.payload.data) {
          setTotal(
            response.payload.data.total ? response.payload.data.total : 0,
          );
        }
      });
  };

  const performPagination = state => {
    setTimeout(() => {
      const offset = state.page * state.pageSize;
      const limit = state.pageSize;
      const tenantId = props.currentUser.queryParams.tenantId;
      setParams({ offset, limit, tenantId });
      if (query) {
        performSearchFn(query, { offset, limit, tenantId });
      }
    }, 0);
  };

  return (
    <div id="content">
      <Helmet title={`Query Builder � ${hostTitle()}`} />
      <BigBreadcrumbs
        items={['Practice Management', 'Query Builder']}
        icon="fa fa-fw fa-hospital-o"
        className=""
      />
      {props.queryBuilder.queries &&
        <div className="btn-group" style={{ marginBottom: '10px' }}>
          <Link to="/query-manager" className="btn btn-default">
            Query Manager
          </Link>
        </div>
      }{` `}
      {props.queryBuilder.queries &&
        <QueryList
          queries={props.queryBuilder.queries}
          applyFilter={e => {
            setInitValue(e);
          }}
          deleteFilter={id => {
            props.deleteQuery(props.currentUser.data.id, id).then(res => {
              props.getQueries(props.currentUser.data.id);
            });
          }}
        />
      }
      {props.queryBuilder.isLoading && !props.queryBuilder.data && (
        <div className="spinner" />
      )}
      {props.queryBuilder.data && (
        <QueryBuilder
          initValue={initValue}
          targets={props.queryBuilder.data}
          onSearch={performSearchFn}
          onChange={val => {
            setInitValue(val);
          }}
          typeahead={props.typeahead}
          addQuery={data => {
            props.addQuery(props.currentUser.data.id, data).then(res => {
              props.getQueries(props.currentUser.data.id);
            });
          }}
        />
      )}
      <ReactTable
        manual
        pages={
          props.queryBuilder.result
            ? Math.ceil(props.queryBuilder.result.total / pageSize)
            : 0
        }
        loading={props.queryBuilder.isSearching}
        data={props.queryBuilder.result ? props.queryBuilder.result.list : []}
        onFetchData={performPagination}
        columns={[
          {
            Header: 'ID',
            id: 'masterPatientId',
            accessor: 'masterPatientId',
            // Cell: row => (<a onClick={() => this.patientProfile(row.original.masterPatientId, row.original.elationId)}>{row.original.masterPatientId}</a>)
          },
          {
            Header: 'First Name',
            id: 'firstName',
            accessor: 'firstName',
          },
          {
            Header: 'Last Name',
            id: 'lastName',
            accessor: 'lastName',
          },
          {
            Header: 'DOB',
            id: 'dob',
            accessor: 'dob',
          },
          {
            Header: 'Gender',
            id: 'gender',
            accessor: 'gender',
          },
          {
            Header: 'Address',
            id: 'addressLine1',
            accessor: 'addressLine1',
          },
          {
            Header: 'Address2',
            id: 'addressLine2',
            accessor: 'addressLine2',
          },
          {
            Header: 'Zip',
            id: 'addressZip',
            accessor: 'addressZip',
          },
          // {
          //   Header: 'Employer Code',
          //   id: 'employerCode',
          //   accessor: 'employerCode',
          // },
          // {
          //   Header: 'Elation ID',
          //   id: 'elationId',
          //   accessor: 'elationId',
          // },
        ]}
        defaultPageSize={pageSize}
        className="-striped -highlight"
        showPaginationTop={true}
        onPageSizeChange={pageSize => setPageSize(pageSize)}
        onPageChange={page => setPage(page)}
      />
    </div>
  );
}

export default connect(
  state => ({
    queryBuilder: state.queryBuilder,
    currentUser: state.currentUser,
  }),
  dispatch => ({
    getQueryBuilderData: params => dispatch(requestQueryBuilderData(params)),
    performSearch: (data, params) => dispatch(performSearch(data, params)),
    typeahead: (url, params) => dispatch(requestTypeahead(url, params)),
    getQueries: (userID, params) => dispatch(requestQueries(userID, params)),
    addQuery: (userID, body) => dispatch(addQuery(userID, body)),
    deleteQuery: (userID, queryID) => dispatch(deleteQuery(userID, queryID)),
  }),
)(QueryBuilderContainer);



// WEBPACK FOOTER //
// ./src/routes/management/containers/QueryBuilder.js